import { useGame } from '../state/store'
import { GLOBAL } from '../config/global'
import { GAUGE } from '../config/colors'

function GaugeBar({
  label,
  value,
  min,
  max,
  colorPositive,
  colorNegative,
}: {
  label: string
  value: number
  min: number
  max: number
  colorPositive: string
  colorNegative: string
}) {
  const range = max - min
  const zeroPos = ((0 - min) / range) * 100
  const valuePos = ((value - min) / range) * 100
  const left = Math.min(zeroPos, valuePos)
  const width = Math.abs(valuePos - zeroPos)
  const color = value >= 0 ? colorPositive : colorNegative

  return (
    <div className="flex items-center gap-3 text-xs">
      <span className="w-16 font-bold uppercase tracking-wider text-ink-muted">
        {label}
      </span>
      <div className="relative h-3 flex-1 rounded-full bg-ink-border">
        {/* Zero tick */}
        <div
          className="absolute top-0 h-full w-px bg-ink-muted"
          style={{ left: `${zeroPos}%` }}
        />
        {/* Value bar */}
        <div
          className="absolute top-0 h-full rounded-full transition-all duration-150"
          style={{ left: `${left}%`, width: `${width}%`, backgroundColor: color }}
        />
      </div>
      <span className="w-12 text-right tabular-nums text-ink-text">
        {value > 0 ? '+' : ''}{Math.round(value)}
      </span>
    </div>
  )
}

export function ForgeMetrics() {
  const heat = useGame((s) => s.heat)
  const weight = useGame((s) => s.weight)

  return (
    <div className="mt-4 grid gap-3 rounded-lg border border-ink-border bg-ink-panel p-4 sm:grid-cols-2">
      <GaugeBar
        label="Ink"
        value={heat}
        min={GLOBAL.heatMin}
        max={GLOBAL.heatMax}
        colorPositive={GAUGE.inkPositive}
        colorNegative={GAUGE.inkNegative}
      />
      <GaugeBar
        label="Press"
        value={weight}
        min={GLOBAL.weightMin}
        max={GLOBAL.weightMax}
        colorPositive={GAUGE.pressPositive}
        colorNegative={GAUGE.pressNegative}
      />
    </div>
  )
}
